<template>
  <div id="carousel-example-2" class="carousel slide" data-ride="carousel">
    <ol class="carousel-indicators">
      <li data-target="#carousel-example-2" data-slide-to="0" class="active"></li>
      <li data-target="#carousel-example-2" data-slide-to="1"></li>
      <li data-target="#carousel-example-2" data-slide-to="2"></li>
    </ol>
    <div class="carousel-inner" role="listbox">
      <div class="carousel-item active">
        <div class="view" >
          <img class="d-none d-sm-block mx-auto " src="../assets/slider_unete.png" height="310px"
               alt="First slide">
          <img class="d-block d-sm-none mx-auto " src="../assets/slider_unete.png" height="110px"
               alt="First slide">
          <div class="mask "></div>
        </div>
        <div class="carousel-caption w-100" style="background-color: #00A492;  height: 270px">
          <h3 class="h3-responsive">¡ÚNETE!</h3>
          <h2 class="mb-5 h2-responsive">Se parte de las más de 40 empresas <br>
            distribuidoras de Movistar® y At&t® que ya <br>
            ocupan nuestras soluciones.</h2>
        </div>
      </div>
      <div class="carousel-item ">
        <div class="view" style="margin-top: 120px;">
          <img class="d-none d-sm-block mx-auto " src="../assets/slider_aumenta.png" height="400px"
               alt="First slide">
          <img class="d-block d-sm-none mx-auto " src="../assets/slider_aumenta.png" height="200px"
               alt="First slide">
          <div class="mask "></div>
        </div>
        <div class="carousel-caption w-100" style="background-color: #00A492;  height: 270px">
          <h3 class="h3-responsive">AUMENTA LA CALIDAD</h3>
          <h2 class="mb-5 h2-responsive">El negocio evoluciona, evoluciona con el.</h2>
        </div>
      </div>
      <div class="carousel-item ">
        <div class="view" style="margin-top: 120px;">
          <img class="d-none d-sm-block mx-auto " src="../assets/slider_momento.png" height="400px"
               alt="First slide">
          <img class="d-block d-sm-none mx-auto " src="../assets/slider_momento.png" height="200px"
               alt="First slide">
          <div class="mask "></div>
        </div>
        <div class="carousel-caption w-100" style="background-color: #00A492;  height: 270px">
          <h3 class="h3-responsive">¡ES EL MOMENTO!</h3>
          <h2 class="mb-5 h2-responsive">"Toma el control de la manera mas eficiente."</h2>
        </div>
      </div>
    </div>
<!--    <a class="carousel-control-prev" href="#carousel-example-2" role="button" data-slide="prev">-->
<!--      <span class="carousel-control-next-icon" aria-hidden="true">-->
<!--        <i class="fas fa-chevron-left fa-5x"></i>-->
<!--      </span>-->
<!--      <span class="sr-only">Previous</span>-->
<!--    </a>-->
<!--    <a class="carousel-control-next" href="#carousel-example-2" role="button" data-slide="next">-->
<!--      <span class="carousel-control-next-icon" aria-hidden="true">-->
<!--       <i class="fas fa-chevron-right fa-5x"></i>-->
<!--      </span>-->
<!--      <span class="sr-only">Next</span>-->
<!--    </a>-->
  </div>
</template>

<script>
  export default {
    name: "Carousel"
  }
</script>

<style scoped>
  .view {
    margin-top: 210px;
    margin-bottom: 60px;
  }

  span {
    color: #00A492;
  }

  li {
    color: #00A492;
    background-color: #00A492;
  }

  .carousel .carousel-indicators li {
    width: 5rem;
    height: .7rem;
    border-radius: 2rem;
  }

  .carousel-caption {
    top: 0px;
    left: initial;
    right: initial;
    bottom: initial;
    z-index: -10;
  }
</style>
